export default function AuthUserSettings({ contentData, initError, initLoader }) {
  return <div>This is Auth User Settings page</div>;
}
